import React, { useState, forwardRef } from 'react'
import { Input, Select } from '../../../components'

// Generic single-field bulk editor — reused for both "reassign owner" and
// "update source" since they're otherwise identical (one field, applied to
// every selected candidate). `field`/`label`/`type`/`options` come from the
// dialog config in useCandidateDialog; `data` is the selected candidates.
const _CandidateBulkEditForm = ({ field, label, type, options, data, submitForm, loading, setLoading }, ref) => {

  const [value, setValue] = useState('')
  const [invalid, setInvalid] = useState(false)

  const handleChange = (event) => {
    setInvalid(false)
    setValue(event.target !== undefined ? event.target.value : event.value)
  }

  const onSubmit = (event) => {
    event.preventDefault()

    if (type === 'select' && !value) {
      setInvalid(true)
      return
    }

    setLoading(true)
    submitForm({ [field]: type === 'select' ? Number(value) : value.trim() })
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  return (
    <div className="form">
      <form onSubmit={onSubmit} ref={ref}>

        <p style={{ color: 'var(--color-dark-grey)', marginBottom: 16 }}>Gäller {data.length} kandidat{data.length > 1 ? 'er' : ''}.</p>

        <div className="form-block vertical">
          <label>{label}</label>
          {type === 'select'
            ? <Select
                name={field}
                value={value}
                options={options}
                onChange={handleChange}
                disabled={loading}
                invalid={invalid}
                placeholder="Välj…"
              />
            : <Input type="text" name={field} value={value} onChange={handleChange} disabled={loading} invalid={invalid} />
          }
        </div>

      </form>
    </div>
  )
}

export const CandidateBulkEditForm = forwardRef(_CandidateBulkEditForm)
